<div class="detail-vision">
  <div class="data-chart mb-6">
    <div
      class="d-flex flex-wrap justify-content-between align-items-center mb-3 ms-xxl-6 me-xxl-4"
    >
      <h1 class="fs-2 me-3 my-1">
        <ng-container
          *appSkeletonLoader="
            loading;
            style: { height: '2.5rem', width: '10rem' }
          "
        >
          <span i18n="@@patient_evaluationVision_title">Vision</span>
        </ng-container>
      </h1>
      <form [formGroup]="dateRangeForm">
        <div class="data-chart__filter row align-items-center my-1">
          <div class="col-auto pe-0">
            <ng-container
              *appSkeletonLoader="
                loading;
                style: { height: '2.5rem', width: '1.8rem' }
              "
            >
              <label
                for="startDate"
                class="col-form-label fw-semi-bold text-gray-70"
                i18n="@@patient_evaluation_fromLabel"
                >From</label
              >
            </ng-container>
          </div>
          <div class="col-auto">
            <div class="form-group">
              <ng-container
                *appSkeletonLoader="
                  loading;
                  style: { height: '2.5rem', width: '8rem' }
                "
              >
                <div
                  class="input-group"
                  ngbDropdown
                  #dropdownStartDate="ngbDropdown"
                  autoClose="outside"
                  placement="bottom-right"
                >
                  <input
                    type="text"
                    class="form-control form-control--monthpicker bg-white"
                    placeholder="MM/AAAA"
                    i18n-placeholder="@@patient_evaluation_fromPlaceholder"
                    name="startDate"
                    formControlName="startDate"
                    [ngClass]="{
                      'border-danger':
                        dateRangeForm.get('startDate').invalid &&
                        !dateRangeForm.get('startDate').pristine
                    }"
                  />
                  <button
                    type="button"
                    class="dropdown-toggle-split"
                    id="dropdownStartDate"
                    [ngClass]="{
                      'border-danger':
                        dateRangeForm.get('startDate').invalid &&
                        !dateRangeForm.get('startDate').pristine
                    }"
                    ngbDropdownToggle
                  >
                    <img
                      src="assets/icons/icon_calendar.svg"
                      class="img-fluid"
                      alt="calendar"
                    />
                  </button>
                  <div
                    ngbDropdownMenu
                    class="p-0"
                    aria-labelledby="dropdownStartDate"
                  >
                    <app-monthpicker
                      (selected)="
                        changeDateRange($event, 'startDate');
                        dropdownStartDate.close()
                      "
                      [year]="getDateYear('startDate')"
                      [month]="getDateMonth('startDate')"
                    ></app-monthpicker>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
          <div class="col-auto px-0">
            <ng-container
              *appSkeletonLoader="
                loading;
                style: { height: '2.5rem', width: '1.8rem' }
              "
            >
              <label
                for="endDate"
                class="col-form-label fw-semi-bold text-gray-70"
                i18n="@@patient_evaluation_toLabel"
                >to</label
              >
            </ng-container>
          </div>
          <div class="col-auto">
            <div class="form-group">
              <ng-container
                *appSkeletonLoader="
                  loading;
                  style: { height: '2.5rem', width: '7rem' }
                "
              >
                <div
                  class="input-group"
                  ngbDropdown
                  #dropdownEndDate="ngbDropdown"
                  autoClose="outside"
                  placement="bottom-right"
                >
                  <input
                    class="form-control form-control--monthpicker bg-white"
                    placeholder="MM/AAAA"
                    i18n-placeholder="@@patient_evaluation_toPlaceholder"
                    id="endDate"
                    formControlName="endDate"
                    [ngClass]="{
                      'border-danger':
                        dateRangeForm.get('endDate').invalid &&
                        !dateRangeForm.get('endDate').pristine
                    }"
                  />
                  <button
                    type="button"
                    class="dropdown-toggle-split"
                    id="dropdownEndDate"
                    [ngClass]="{
                      'border-danger':
                        dateRangeForm.get('endDate').invalid &&
                        !dateRangeForm.get('endDate').pristine
                    }"
                    ngbDropdownToggle
                  >
                    <img
                      src="assets/icons/icon_calendar.svg"
                      class="img-fluid"
                      alt="icon"
                    />
                  </button>
                  <div
                    ngbDropdownMenu
                    class="p-0"
                    aria-labelledby="dropdownEndDate"
                  >
                    <app-monthpicker
                      (selected)="
                        changeDateRange($event, 'endDate');
                        dropdownEndDate.close()
                      "
                      [year]="getDateYear('endDate')"
                      [month]="getDateMonth('endDate')"
                    ></app-monthpicker>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </div>
      </form>
    </div>
    <div class="data-chart__monoyer">
      <h3
        class="fs-5"
        i18n="@@patient_evaluationVision_realizedEvaluationsTitle"
      >
        Monoyer Acuity
      </h3>
      <app-chart
        [loading]="loadingChart"
        [chartDatasets]="monoyerDatasets"
        [chartXLabels]="xLabels"
        [chartHorizontalLimitLines]="evaluation.horizontalLimitLines"
        (toggledFeatureDisplay)="updateChartDescriptionFeature($event)"
      ></app-chart>
    </div>
  </div>
  <div class="py-4">
    <ngb-accordion #a="ngbAccordion" activeIds="desc_test, desc_situation">
      <ngb-panel id="desc_test">
        <ng-template ngbPanelHeader>
          <div class="d-flex align-items-center justify-content-between">
            <h3 class="m-0">
              <ng-container
                *appSkeletonLoader="
                  loading;
                  style: { height: '1.6rem', width: '10rem' }
                "
              >
                <span i18n="@@patient_evaluation_evaluationDescriptionTitle"
                  >Evaluation description</span
                >
              </ng-container>
            </h3>
            <div>
              <ng-container
                *appSkeletonLoader="
                  loading;
                  type: 'circle';
                  style: { height: '2.6rem', width: '2.6rem' }
                "
              >
                <button ngbPanelToggle class="btn btn-link p-0">
                  <img
                    [src]="
                      a.isExpanded('desc_test')
                        ? 'assets/icons/icon-dropdown-close.svg'
                        : 'assets/icons/icon-dropdown-open.svg'
                    "
                    alt="icon"
                  />
                </button>
              </ng-container>
            </div>
          </div>
        </ng-template>
        <ng-template ngbPanelContent>
          <div class="content-card">
            <ng-container
              *appSkeletonLoader="loading; style: { height: '12rem' }"
            >
              <div>
                <u i18n="@@patient_evaluation_evaluationDescriptionContentTitle"
                  >Principe de l’évaluation :</u
                >
                <br />
                <p
                  i18n="
                    @@patient_evaluationVision_evaluationDescriptionContentP1"
                >
                  Ce test consiste à afficher aux patients des nombres sombres
                  aléatoires (optotypes) sur un fond blanc avec un contraste
                  fixe égal à 5% (±0,1%) avec une taille qui diminue
                  progressivement à chaque ligne (contraste de Michelson). Ce
                  test est basé sur le test d'acuité des lettres à faible
                  contraste de Sloan (SLCLA).
                </p>
                <p
                  i18n="
                    @@patient_evaluationVision_evaluationDescriptionContentP2"
                >
                  Les patients doivent porter leur aide visuelle habituelle et
                  s'asseoir dans une pièce calme, à lumière ambiante. Les
                  patients devront se placer à 1 mètre du smartphone et
                  reconnaître chaque nombre affiché. Pour chaque nombre, ils
                  disposent d'un temps maximum de 10 secondes pour fournir une
                  réponse à chaque nombre affiché.
                </p>
                <p
                  i18n="
                    @@patient_evaluationVision_evaluationDescriptionContentP3"
                >
                  Les patients pourront sauter un nombre particulier s'ils ne
                  connaissent pas la réponse (mais ce cas sera considéré comme
                  une mauvaise réponse). Après 3 échecs consécutifs, la lecture
                  de la ligne est considérée comme un échec. La séquence se
                  termine après 55 nombre affichés, avec 5 nombre affichés par
                  ligne.<br />Le test est capable d'évaluer les deux yeux
                  ouverts (condition binoculaire) et chaque œil à la fois.
                </p>
              </div>
              <div>
                <u
                  i18n="
                    @@patient_evaluation_evaluationDescriptionConditionTitle"
                  >Condition de validité du test :</u
                >
                <br />
                <p
                  i18n="
                    @@patient_evaluationVision_evaluationDescriptionContentP4"
                >
                  Le test sera considéré comme valide si le patient réalise 3
                  échecs consécutifs, ou si toutes les lignes ont été répondues
                  avec succès. Si le patient quitte le test de lui-même, le test
                  est considéré comme non valide et les résultats ne seront pas
                  enregistrés.
                </p>
              </div>
              <div>
                <u i18n="@@patient_evaluation_evaluationDescriptionResultTitle"
                  >Résultats :</u
                ><br /><span
                  i18n="
                    @@patient_evaluationVision_evaluationDescriptionResultContent"
                  >Les données recueillies permettent de fournir les
                  informations suivantes :
                </span>
                <ul class="list">
                  <li
                    i18n="
                      @@patient_evaluationVision_evaluationDescriptionResultLi1"
                  >
                    Acuité visuelle (Monoyer) Oeil gauche
                  </li>
                  <li
                    i18n="
                      @@patient_evaluationVision_evaluationDescriptionResultLi2"
                  >
                    Acuité visuelle (Monoyer) Oeil droit
                  </li>
                  <li
                    i18n="
                      @@patient_evaluationVision_evaluationDescriptionResultLi3"
                  >
                    Acuité visuelle (Monoyer) Oeil binoculaire
                  </li>
                </ul>
              </div>
            </ng-container>
          </div>
        </ng-template>
      </ngb-panel>
      <ngb-panel id="desc_situation">
        <ng-template ngbPanelHeader let-opened="opened">
          <div
            class="d-flex align-items-center justify-content-between line-top"
          >
            <h3 class="m-0">
              <ng-container
                *appSkeletonLoader="
                  loadingChart;
                  style: { height: '1.6rem', width: '10rem' }
                "
              >
                <span i18n="@@patient_evaluation_situationDescriptionTitle"
                  >Situation description</span
                >
              </ng-container>
            </h3>
            <div>
              <ng-container
                *appSkeletonLoader="
                  loadingChart;
                  type: 'circle';
                  style: { height: '2.6rem', width: '2.6rem' }
                "
              >
                <button ngbPanelToggle class="btn btn-link p-0">
                  <img
                    [src]="
                      a.isExpanded('desc_situation')
                        ? 'assets/icons/icon-dropdown-close.svg'
                        : 'assets/icons/icon-dropdown-open.svg'
                    "
                    alt="icon"
                  />
                </button>
              </ng-container>
            </div>
          </div>
        </ng-template>
        <ng-template ngbPanelContent>
          <div class="content-card">
            <ng-container
              *appSkeletonLoader="loadingChart; style: { height: '12rem' }"
            >
              <app-chart-description
                [startDate]="dateRangeForm.get('startDate').value"
                [endDate]="dateRangeForm.get('endDate').value"
                [patient]="patientProfile"
                [xLabels]="xLabels"
                [chartDescription]="chartDescription"
              ></app-chart-description>
            </ng-container>
          </div>
        </ng-template>
      </ngb-panel>
    </ngb-accordion>
  </div>
</div>
